import { Edit, LockOpen, LockPerson } from '@mui/icons-material';
import { IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useMemo } from 'react';

import { UserAffiliations, USER_AFFILIATIONS_OPTIONS } from '@jebel/constants';

import { ContentRestrictionFragment } from 'shared/graphql';

interface Props {
  restriction: ContentRestrictionFragment;

  /**
   * Callback to edit the restriction.
   */
  onEdit: () => void;
}

const AFFILIATION_LABELS = Object.fromEntries(
  USER_AFFILIATIONS_OPTIONS.map(option => [option.value, option.label]),
) as Record<UserAffiliations, string>;

export function ContentRestrictionListItem({ restriction, onEdit }: Props) {
  const audienceAffiliationsLabels = useMemo(() => {
    const affiliations = restriction.audience.affiliations ?? [];

    return affiliations
      .map(affiliation => AFFILIATION_LABELS[affiliation])
      .filter(Boolean)
      .join(', ');
  }, [restriction.audience]);

  return (
    <ListItem
      secondaryAction={
        <IconButton onClick={onEdit}>
          <Edit />
        </IconButton>
      }
    >
      <ListItemIcon>{restriction.isActive ? <LockPerson /> : <LockOpen />}</ListItemIcon>

      <ListItemText
        primary={restriction.description}
        secondary={restriction.isActive ? audienceAffiliationsLabels : 'Disabled'}
      />
    </ListItem>
  );
}
